import { RouteId } from 'types/frontend_models/navigation/RouteId';
import Dashboard from 'components/content/dashboard/Dashboard';
import { RouteComponentProps } from 'react-router-dom';
import OrdersPage from 'components/content/orders/OrdersPage';
import OrderDetailPage from 'components/content/orders/detail/OrderDetailPage';
import OrdersOverviewPage from 'components/content/orders/overview/OrdersOverviewPage';
import DeliveriesPage from 'components/content/deliveries/DeliveriesPage';
import DeliveriesOverviewPage from 'components/content/deliveries/overview/DeliveriesOverviewPage';
import DeliveryDetailPage from 'components/content/deliveries/detail/DeliveryDetailPage';
import { InvoicesPage } from 'components/content/invoices/InvoicesPage';
import { InvoicesOverViewPage } from 'components/content/invoices/overview/InvoicesOverviewPage';
import { InvoiceDetailPage } from 'components/content/invoices/detail/InvoicesDetailPage';
import { ProductsPage } from 'components/content/products/ProductsPage';
import { ProductsOverViewPage } from 'components/content/products/overview/ProductsOverviewPage';
import { ProductDetailPage } from 'components/content/products/detail/ProductDetailPage';
import { LibraryPage } from 'components/content/library/LibraryPage';
import { LibraryDocumentsOverViewPage } from 'components/content/library/overview/LibraryDocumentsOverviewPage';





export interface IRoute
{
    /** Route identifier */
    routeId: RouteId,
    /** Route url path */
    path: string,
    exact: boolean,
    /** Component it renders */
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
}

export const rootPath = process.env.REACT_APP_ROOT_PATH;
// console.log('rootPath', rootPath);

export const sidebarRoutes: IRoute[] = [
    {
        routeId: RouteId.home,
        path: `${rootPath}/home`,
        exact: true,
        component: Dashboard
    },
    {
        routeId: RouteId.library,
        path: `${rootPath}/library`,
        exact: false,
        component: LibraryPage
    },
    {
        routeId: RouteId.orders,
        path: `${rootPath}/orders`,
        exact: false,
        component: OrdersPage
    },
    {
        routeId: RouteId.deliveries,
        path: `${rootPath}/deliveries`,
        exact: false,
        component: DeliveriesPage
    },
    {
        routeId: RouteId.invoices,
        path: `${rootPath}/invoices`,
        exact: false,
        component: InvoicesPage
    },
    {
        routeId: RouteId.products,
        path: `${rootPath}/products`,
        exact: false,
        component: ProductsPage
    }
];

export const libraryPageRoutes: IRoute[] = [
    {
        routeId: RouteId.libraryDocumentsOveriew,
        path: `${rootPath}/library/documents-overview`,
        exact: true,
        component: LibraryDocumentsOverViewPage
    }
];

export const orderPageRoutes: IRoute[] = [
    {
        routeId: RouteId.ordersOverview,
        path: `${rootPath}/orders/overview`,
        exact: true,
        component: OrdersOverviewPage
    },
    {
        routeId: RouteId.orderDetail,
        path: `${rootPath}/orders/detail`,
        exact: false,
        component: OrderDetailPage
    }
];

export const deliveriesPageRoutes: IRoute[] = [
    {
        routeId: RouteId.deliveriesOverview,
        path: `${rootPath}/deliveries/overview`,
        exact: true,
        component: DeliveriesOverviewPage
    },
    {
        routeId: RouteId.deliveryDetail,
        path: `${rootPath}/deliveries/detail`,
        exact: true,
        component: DeliveryDetailPage
    }
]

export const productsPageRoutes: IRoute[] = [
    {
        routeId: RouteId.productsOverview,
        path: `${rootPath}/products/overview`,
        exact: true,
        component: ProductsOverViewPage
    },
    {
        routeId: RouteId.productDetail,
        path: `${rootPath}/products/detail`,
        exact: true,
        component: ProductDetailPage
    }
];

export const invoicesPageRoutes: IRoute[] = [
    {
        routeId: RouteId.invoicesOverview,
        path: `${rootPath}/invoices/overview`,
        exact: true,
        component: InvoicesOverViewPage
    },
    {
        routeId: RouteId.invoiceDetail,
        path: `${rootPath}/invoices/detail`,
        exact: true,
        component: InvoiceDetailPage
    }
];

export const allRoutes: IRoute[] = [
    ...sidebarRoutes,
    ...libraryPageRoutes,
    ...orderPageRoutes,
    ...deliveriesPageRoutes,
    ...productsPageRoutes,
    ...invoicesPageRoutes
];

/* OLD CODE */

// export const LANDING = '/';
// export const PROTECTED = '/myaptec';
// export const SIGN_IN = '/login';

// export const root = {
//     path: '/myaptec',
//     menu: [{
//             name: 'v1', //in componenten nog vervangen door verwijzing in routes[]
//             children: ['dashboard', 'accounts', 'products', 'purchaseorders', 'orders', 'production', 'documents'],
//         },
//         {
//             name: 'add',
//             children: [
//                 // 'account_overview',
//                 // 'divider', 
//                 // 'product_overview', 
//                 // 'price_overview', 
//                 // 'divider', 
//                 // 'supplier_overview',
//                 // 'purchaserequisition',
//                 // 'purchaseorder_overview',
//                 // 'goodsreceipt_overview',
//                 // 'purchaseinvoice',
//             ],
//         },
//         {
//             name: 'settings',
//             children: [
//                 'logs',
//             ],
//         },
//     ]
// }

// export const submenus = {
//     account: ['account_overview', 'account_pricelist', 'account_documents', 'account_invoices', 'account_orders', 'account_supplierproducts'],
//     product: ['product_overview', 'product_pricelist', 'product_bom', 'product_stock', 'product_supplier'],
//     stock: ['stock_overview', 'stock_used', 'stock_allocated', 'stock_history'],
//     // only used for sidebar menu v2
//     accounts: ['accounts', 'contacts'],
//     products: ['products', 'pricing', 'stock', 'isa'],
//     suppliers: ['suppliers', 'purchaserequisitions', 'purchaseorders', 'goodsreceipt'],
//     orders: ['orders', 'deliveries', 'salesinvoices', 'collections'],
//     productionorders: ['productionorders', 'coas'],
// }

// export const menuTree = [
//     {
//         name: 'dashboard',
//         header: true,
//         highlightHeader: true
//     },
//     {
//         name: 'orders',
//         header: true,
//         label: 'Order to Cash',
//         new: 'order'
//     },
//     {
//         name: 'orders'
//     }
// ]